import { MutationTree } from 'vuex';
import { State } from './errors.store';

const mutations: MutationTree<State> = {
  setCurrentEvent(state: State, data: any) {
    state.currentEventItem = data;
  },
  setCurrentEventID(state: State, data: any) {
    state.currentEventID = data;
  },
  setErrorsFromPage(state: State, data: any) {
    state.errorsFromPage = data;
  }
};

export default mutations;
